import store from '@state/store'

var routesred = [
  {
    path: '/post/:id',
    name: 'post',
    component: () => lazyLoadView(import('@views/red_colaborativa/post')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/red_colaborativa/index')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/grupos_de_interes',
    name: 'interest_groups',
    component: () => lazyLoadView(import('@views/red_colaborativa/interest_groups')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/repositorios/',
    name: 'repositories',
    component: () => lazyLoadView(import('@views/red_colaborativa/document')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/herramientas',
    name: 'tools',
    component: () => lazyLoadView(import('@views/red_colaborativa/tools')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/foros',
    name: 'forum',
    component: () => lazyLoadView(import('@views/red_colaborativa/forum')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/agendas',
    name: 'courses',
    component: () => lazyLoadView(import('@views/red_colaborativa/courses')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/TAC',
    name: 'tac',
    component: () => lazyLoadView(import('@views/red_colaborativa/about_us')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/acerca_de',
    name: 'about_us',
    component: () => lazyLoadView(import('@views/red_colaborativa/concerning')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/agenda/:id',
    name: 'course',
    component: () => lazyLoadView(import('@views/red_colaborativa/course')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/acta_constitucion',
    name: 'acta_constitucion',
    component: () => lazyLoadView(import('@views/red_colaborativa/minutas/MinutaActaConstitucion')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/presentacion_personeria',
    name: 'presentacion_personeria',
    component: () => lazyLoadView(import('@views/red_colaborativa/minutas/MinutaPresentacionPersoneria')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/solicitud_certificacion',
    name: 'solicitacion_certificacion',
    component: () => lazyLoadView(import('@views/red_colaborativa/minutas/MinutaSolicitudCertificacion')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/derecho_de_peticion',
    name: 'derecho_de_peticion',
    component: () => lazyLoadView(import('@views/red_colaborativa/minutas/MinutaDerechoPeticion')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },


  {
    path: '/accion_de_tutela',
    name: 'accion_de_tutela',
    component: () => lazyLoadView(import('@views/red_colaborativa/minutas/MinutaAccionTutela')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/admin',
    name: 'admin',
    component: () => lazyLoadView(import('@views/red_colaborativa/admin')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/groups',
    name: 'groups',
    component: () => lazyLoadView(import('@views/red_colaborativa/groups')),
    meta: {
      authRequired: false,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'admin' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
              name: 'login',
              params: routeTo.params ? routeTo.params : {},
            }
            : { ...routeFrom }
        )
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/reset-password/:uuid/',
    name: 'reset-password',
    component: () => lazyLoadView(import('@views/resetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/management/users/',
    name: 'users',
    component: () => import('@views/management/users/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/groups/',
    name: 'groups',
    component: () => import('@views/management/groups/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/perms/',
    name: 'perms',
    component: () => import('@views/management/perms/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/app-sections/',
    name: 'app-sections',
    component: () => import('@views/management/app-sections/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/company-info/',
    name: 'company-info',
    component: () => import('@views/management/company-info/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/management/security/',
    name: 'security',
    component: () => import('@views/management/security/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/management/content-creators/',
    name: 'content-creators',
    component: () =>
      lazyLoadView(import('@views/management/content-creators/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/contenido/',
    name: 'content',
    component: () => lazyLoadView(import('@views/content/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/agendas/administracion',
    name: 'courses-admin',
    component: () => lazyLoadView(import('@views/courses/courses')),
    meta: {
      authRequired: true,
      // isAdminRequired:true
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/foros/administracion',
    name: 'foros',
    component: () => lazyLoadView(import('@views/foros/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
export default routesred
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
